import { useEffect, useState } from 'react';
import { editorScrollRootRef, previewScrollRootRef } from '../utils/defaults';

/** Détecte le scroll (page publique, éditeur, aperçu) pour le menu overlay. */
export function usePageMenuScrolled(enabled, threshold = 16) {
  const [scrolled, setScrolled] = useState(false);

  useEffect(() => {
    if (!enabled) {
      setScrolled(false);
      return undefined;
    }

    const readScroll = () => {
      const y = Math.max(
        window.scrollY || 0,
        document.documentElement.scrollTop || 0,
        editorScrollRootRef.current?.scrollTop || 0,
        previewScrollRootRef.current?.scrollTop || 0,
      );
      setScrolled(y > threshold);
    };

    readScroll();

    const opts = { passive: true };
    window.addEventListener('scroll', readScroll, opts);
    document.addEventListener('scroll', readScroll, opts);

    const roots = [editorScrollRootRef.current, previewScrollRootRef.current].filter(Boolean);
    roots.forEach((el) => el.addEventListener('scroll', readScroll, opts));

    const interval = window.setInterval(readScroll, 400);

    return () => {
      window.removeEventListener('scroll', readScroll);
      document.removeEventListener('scroll', readScroll);
      roots.forEach((el) => el.removeEventListener('scroll', readScroll));
      window.clearInterval(interval);
    };
  }, [enabled, threshold]);

  return scrolled;
}
